import { IThemeVariables } from './themeVariables';
import { variables } from './variables';

export interface ICybsTheme {
  base: any;
  component: any;
  core: any;
}

export const getCybsTheme = ({ CSS_VARS }: IThemeVariables): ICybsTheme => ({
  // Color palettes for CYBS and VAULT
  // These colors are never affected by theming
  base: variables.base,

  // Component colors are themed completely independent from core colors
  // These colors are manipulated on a 1:1 basis per the appropriate color override
  // They are taken and set unchanged at face value and are not affected by the color algorithm
  component: {
    footer: {
      background: CSS_VARS.footerBackground,
      link: CSS_VARS.footerLink,
      text: CSS_VARS.footerText
    },
    navbar: {
      background: CSS_VARS.navbarBackground,
      backgroundSelected: CSS_VARS.navbarBackgroundSelected,
      dropdownSelected: CSS_VARS.navbarDropdownSelected,
      foreground: CSS_VARS.navbarForeground,
      indicatorBar: CSS_VARS.navbarIndicatorBar,
      rollover: CSS_VARS.navbarRollover
    },
    topbar: {
      background: CSS_VARS.topbarBackground,
      foreground: CSS_VARS.topbarForeground,
      partnerLink: CSS_VARS.topbarPartnerLink,
      portalText: CSS_VARS.topbarPortalText
    }
  },

  // Core colors affect all components that are not independently themed
  core: {
    // Only themed by primary color override
    primary: CSS_VARS.primary,
    // Indirectly themed by primary color override
    primaryDark: CSS_VARS.primaryDark,

    // Indirectly themed by primary color override or directly themed by secondary color override
    secondary: CSS_VARS.secondary,

    // Indirectly themed by primary color override or directly themed by tertiary color override
    tertiary: CSS_VARS.tertiary,

    // Only themed by link color override
    link: CSS_VARS.linkColor,

    // TODO: remove legacy support in a future major release
    // Legacy name for link color override
    linkColor: CSS_VARS.linkColor
  }
});
